module.exports = __webpack_public_path__ + "c56eee9f640a9b95c08588744116fa24.pdf";